/** English (source of truth). All other locales fall back to these keys. */
export const en = {
  // Nav
  'nav.features':  'Features',
  'nav.pricing':   'Pricing',
  'nav.templates': 'Templates',
  'nav.blog':      'Blog',
  'nav.login':     'Log in',
  'nav.register':  'Get MyDay free',

  // Hero
  'hero.badge':   'New — AI assistant writes boards for you',
  'hero.title.a': 'Your team\'s',
  'hero.title.b': 'new favorite',
  'hero.title.c': 'Work OS.',
  'hero.subtitle':'Everything Monday.com has, with a splash of neon, a dollop of pastel, and an AI that actually gets work done. Plan, track, and ship — together.',
  'hero.cta.primary':   'Get MyDay free',
  'hero.cta.secondary': 'See all features',
  'hero.notice':        'No credit card · Free forever plan · 3-minute setup',

  // Auth
  'auth.login.title':    'Welcome back.',
  'auth.login.subtitle': 'Good to see you. Let\'s get today moving.',
  'auth.register.title': 'Make MyDay yours.',
  'auth.register.subtitle': '3 minutes to your first board. No credit card, no gotchas.',

  // Common
  'common.cancel': 'Cancel',
  'common.save':   'Save',
  'common.delete': 'Delete',
  'common.new':    'New',
};

export type TranslationKey = keyof typeof en;
